<template>
  <div class="section-content">
    <NewsCenter
      v-if="token"
      :serveUrl="serveUrl"
      :pageNo.sync="pageNo"
      :pageSize="pageSize"
      :props="props"
      :colId="colId"
      :maxLength="maxLength"
      :request="request"
			:displayMode.sync="displayMode"
      @pageNoReset="pageNo = 0"
      @lookDetails="item => look(item)"
    />
    <NewsCenter
      v-else
      openApi
      :serveUrl="serveUrl"
      :pageNo.sync="pageNo"
      :pageSize="pageSize"
      :props="props"
      :colId="colId"
      :maxLength="maxLength"
      :request="request"
      @pageNoReset="pageNo = 0"
      @lookDetails="item => look(item)"
			:displayMode.sync="displayMode"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import configR from '@/configs.js';

export default {
  name: "News",
  computed: {
    ...mapGetters(["token",  "request"]),
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 20,
      props: {
        value: "id",
        label: "columnName",
      },
      maxLength: 5,
      colId: "",
      serveUrl:configR.envConfigs.PORTAL_API,
			displayMode:configR.envConfigs.VUE_APP_SHOW_NEWS_DISPLAYMODE === 'list' ? "list":'card',
    };
  },
  watch: {
    "$store.state.app.scrollToBottom"() {
      this.pageNo += 1;
    },
  },
  activated() {
    if (this.$route.query.id) this.colId = this.$route.query.id;
  },
  methods: {
    look(item) {
      if(item.url){
        window.open(item.url)

      }else{
        let a = this.$router.resolve({ name: "NewsDetail", query: { id: item.id } })
         window.open(a.href)
      }
      //this.$router.push({ name: "NewsDetail", params: { id: item.id } });
      //window.open()
      // const { href } = this.$router.resolve({
      //   name: "NewsDetail",
      //   query: {
      //     newsId: item.id
      //   }
      // });
      // window.open(href);
    },
  },
};
</script>
<style lang="scss">
  @import "@/styles/variables.scss";
  .section-content {
    max-width: 1920px;
    margin: 0 auto;
    @include portalMedia;
    .news-center-card {
      width: 100%;
    }
    .news-center-list {
      width: 100%;
    }
  }
</style>
